<template>
    <div class="netgenre">
        <h2 class="netflix-genre-header">Netflix Genres</h2>
 <!--   netflixgenre   start -->
 
            <div class="netflix-trending genre" ref="users">
                <!-- <div class="leftarrow" v-on:click="leftarrow()"><img src="../images/chevron-left-solid.svg"></div>
                <div class="rightarrow" v-on:click="rightarrow()"><img src="../images/chevron-right-solid.svg"></div> -->
                <div class="netflex" v-for=" (netflixgenre,index) in netflixgenres"  v-bind:key="index">
                    <div class="netflix-original-images largeimage">
                        <img :src="`https://image.tmdb.org/t/p/original`+`${netflixgenre.backdrop_path}`">
                        <p> {{ netflixgenre.original_name}} </p>
                                <div class="desc-part">
                                    <div class="icon">
                                        <img src="../images/play-solid.svg">
                                        <img src="../images/plus-circle-solid.svg">
                                        <img src="../images/thumbs-up-solid.svg">
                                        <img src="../images/thumbs-down-solid.svg">
                                    </div>
                                     <div class="desc-sec">
                                        <span class="match" style="color:green">{{netflixgenre.vote_average}}% Match</span>
                                        <span>{{ netflixgenre.overview }}</span>
                                    </div>
                                </div>
                    </div>
            </div>
            </div>

 <!--   netflixgenre  end -->
    </div>
</template>

<script>
import axios from 'axios';
const API_KEY = "c20644006c1a56f0c5eca8d53b6ccf4e";
export default {
    data(){
        return{
             netflixgenres:[],
        }
    },
    created(){
         // genre
               axios.get(`https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_genres=28`)
            .then(topgenres => {
                console.log("genre")
            console.log(topgenres.data.results)
            this.netflixgenres = topgenres.data.results;
            })    
       }
         
    }
    
</script>

<style scoped>
.netgenre{
    margin-top: -38vw;
}
.netflix-trending{
    display: flex;
     overflow-x: scroll;
    margin-top: -20px;
}
 .netflix-original-images{
       width:15vw;
       height:10vw;
       margin-left: 0.2vw;
       /* transition: 0.4s all linear; */
      
       
       transform: scale(1);
       
   }
   .netflix-original-images img{
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
       }
   .netflix-original-images p{
    top: 20%;
    position: absolute;
    transform: translateY(-20%);
        width: 100%;
    font-size: 1vw;
    text-align: center;
    font-family: 'Rock Salt', cursive;
   }
.netflix-genre-header{
   margin-top: -12vw;
   color: white;
}
.netflex:hover .desc-part{
   visibility: visible;
}
.netflex{
    transition: transform .3s;
}
.netflex:hover{
     transform: scale(1.2);
     z-index: 5000;
}
.desc-part{
    color: white;
    height:auto;
    background-color:black;
    z-index: -10;
    transition: 0.1s ease-in;
    visibility: hidden;
    margin-top: -0.7vw;
  }
  .desc-part .icon{
   padding: 20px;
   overflow: hidden;
   display: flex;

  }
  .desc-part .icon img{
      height: 1vw;
      width: 1vw;
      border:1px solid white;
      border-radius: 50%;
      padding: 0.5vw;
      margin-left: 10px;
  }
   .leftarrow,.rightarrow{
      color:white;
  }
  .leftarrow{
  z-index: 50;
     position: absolute;
    height: max-content;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .rightarrow{
      z-index: 50;
     position: absolute; 
    right: 77px;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .netflix-origional:hover .leftarrow,
  .netflix-origional:hover .rightarrow{
   visibility: visible;
  }
  .largeimage.netflix-original-images{
       height: 350px;
       width: 250px;
   }
  
   .genre{
      padding:3vw 0 21vw 0;
      overflow-y: hidden;
      overflow-x: auto;
  }
  .genre::-webkit-scrollbar{
    display: none;
}
 .desc-sec{
      padding: 0 1vw 1vw 1vw;
  }
  .desc-sec span{
      font-size: 10px;
      color: white;
      margin-top: 0vw;
  }
  .match{
      color:green;
      display: block;
      font-weight: 700;
  }
</style>